export default __webpack_public_path__ + "static/media/placeholder-1.b72ff910.jpg";